import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gdp-select-model',
  templateUrl: './select-model.component.html',
  styleUrls: ['./select-model.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectModelComponent),
      multi: true
    }
  ]
})
export class SelectModelComponent implements ControlValueAccessor {
  public selectedModel: string;
  public models: Array<string>;

  @Input() set modelList(models: Array<string>) {
    this.models = models;
    this.selectedModel = this.models[0];
  };

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: string) {
    if (val) {
      this.selectedModel = val;
    }
  }

  public selectModel(model: string) {
    this.selectedModel = model;
    this.onChange(model);
  }
}
